var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"disabled":_vm.isLoading}},[_c('icon-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"mr-2 animate-spin"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }